// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatientModel } from './patientModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientSearchResponseModel {
    'patients'?: Array<PatientModel>;
    'hasAdditionalMatches'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientSearchResponseModel>> = [
        {
            "name":     "patients",
            "baseName": "patients",
            "type":     "Array<PatientModel>"
        },
        {
            "name":     "hasAdditionalMatches",
            "baseName": "hasAdditionalMatches",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return PatientSearchResponseModel.attributeTypeMap;
    }
}
